// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Assets/institution_card_background.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.institution-card-profile {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.institution-card-profile .word-map {
  margin-bottom: 30px;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  position: relative;
}
.institution-card-profile .base-stat .base {
  display: flex;
  width: 100%;
}
.institution-card-profile .base-stat .base .stat-card {
  padding: 5px 15px;
  border-radius: 10px;
  border: 1px solid var(--light-grey);
  margin-right: 10px;
  width: 190px;
}
.institution-card-profile .base-stat .base .stat-card:hover {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  border: 1px solid white;
}
.institution-card-profile .title-part {
  font-size: 25px;
  margin-bottom: 20px !important;
  font-weight: bold;
}
.institution-card-profile .bio {
  margin-bottom: 10px;
}
.institution-card-profile .bio p {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.institution-card-profile .advance-info {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.institution-card-profile .advance-info .advance-stat {
  width: 40%;
}
.institution-card-profile .advance-info .academic-experiences {
  width: 58%;
}`, "",{"version":3,"sources":["webpack://./src/Benchmarking/Scss/InstitutionCard.scss"],"names":[],"mappings":"AAAA;EACE,yDAAA;AACF;AAAE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;AAEJ;AACI;EACE,aAAA;EACA,WAAA;AACN;AAAM;EACE,iBAAA;EACA,mBAAA;EACA,mCAAA;EACA,kBAAA;EACA,YAAA;AAER;AAAM;EACE,0CAAA;EACA,uBAAA;AAER;AAEE;EACE,eAAA;EACA,8BAAA;EACA,iBAAA;AAAJ;AAEE;EACE,mBAAA;AAAJ;AACI;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AACN;AAEE;EACE,WAAA;EACA,aAAA;EACA,8BAAA;AAAJ;AACI;EACE,UAAA;AACN;AACI;EACE,UAAA;AACN","sourcesContent":[".institution-card-profile {\n  background-image: url(\"../Assets/institution_card_background.jpeg\");\n  .word-map {\n    margin-bottom: 30px;\n    padding: 25px;\n    border-radius: 10px;\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);\n    position: relative;\n  }\n  .base-stat {\n    .base {\n      display: flex;\n      width: 100%;\n      .stat-card {\n        padding: 5px 15px;\n        border-radius: 10px;\n        border: 1px solid var(--light-grey);\n        margin-right: 10px;\n        width: 190px;\n      }\n      .stat-card:hover {\n        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);\n        border: 1px solid white;\n      }\n    }\n  }\n  .title-part {\n    font-size: 25px;\n    margin-bottom: 20px !important;\n    font-weight: bold;\n  }\n  .bio {\n    margin-bottom: 10px;\n    p {\n      display: -webkit-box;\n      -webkit-line-clamp: 3;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n    }\n  }\n  .advance-info {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    .advance-stat {\n      width: 40%;\n    }\n    .academic-experiences {\n      width: 58%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
